import { createAction } from '@reduxjs/toolkit';

export const conditionsAdd = createAction<void>(`@@conditions/add`);
export const conditionsDelete = createAction<{ id: string }>(`@@conditions/delete`);
export const conditionsUpdate = createAction<EventCondition>(`@@conditions/update`);

export const conditionsRuleAdd = createAction<{ id: string | void }>(`@@conditions/rule/add`);
export const conditionsRuleDelete = createAction<{ id: string }>(`@@conditions/rule/delete`);
export const conditionsRuleUpdate = createAction<{ id: string; rule?: any }>(`@@conditions/rule/update`);
